import { render, staticRenderFns } from "./RequestResetPassword.vue?vue&type=template&id=78bae75b&"
import script from "./RequestResetPassword.vue?vue&type=script&lang=js&"
export * from "./RequestResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports